import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { COPY_STRINGS } from "Constants/translatedCopy";
import vocabularyIcon from "./vocabulary-icon.png";
import PictureMultipleChoice from "./PictureMultipleChoice";
import { getRandomArrayElement } from "../../../app/utils";
import { shuffle } from "../shared/util";
import "./VocabularyWithPicture.scss";
import { getUserData } from "Services/API";


export default class VocabularyWithPicture extends React.Component {
  isMounted = true;
  
  constructor(props) {
    super(props);
    this.state = {
      isLastQuestion: true, //Only one question
      isFirstQuestion: true, //because we initialize id to 0
      isCorrect: false,
      id: 0, //first one
      buttonsDisabled: true, //TODO do not default to enabled
      results: [],
      isClosed: false,
      distractors: [],
    };

    this.ttsStrings = COPY_STRINGS.intervention_strings.vocabulary_with_picture;
    this.updateResults = this.updateResults.bind(this);
    this.speakEncouragement = this.speakEncouragement.bind(this);
    this.close = this.close.bind(this);
    this.expire = this.expire.bind(this);
    this.enableButtons = this.enableButtons.bind(this);
    this.disableButtons = this.disableButtons.bind(this);
  }

  componentDidMount() {
    this.isMounted = true;
    const { word, wordMetadata } = this.props;

    if (
      !(
        word &&
        wordMetadata &&
        wordMetadata.IMG_URL &&
        wordMetadata.DISTRACTORS &&
        wordMetadata.DEFINITION &&
        wordMetadata.DEFINITION.default
      )
    ) {
      this.close();
      return;
    } else {
      this.setState({
        distractors: shuffle([
          ...wordMetadata.DISTRACTORS,
          wordMetadata.IMG_URL,
        ]),
      });
    }
  }

  componentWillUnmount() {
    this.isMounted = false;
  }

  enableButtons(callback = null) {
    this.setState({ buttonsDisabled: false }, () => {
      if (callback) {
        callback();
      }
    });
  }

  disableButtons(callback = null) {
    this.setState({ buttonsDisabled: true }, () => {
      if (callback) {
        callback();
      }
    });
  }

  speakEncouragement({ text, callback }) {
    this.props.speech.speak({
      textToSpeak: text,
      onEnd: callback,
    });
  }

  updateResults(
    tries,
    selectionHistory,
    response,
    allResponses,
    isCorrect = false
  ) {
    if (!this.isMounted) return;
    const { word, wordMetadata } = this.props;
    let newResults = this.state.results;
    newResults[this.state.id] = {
      tries,
      selectionHistory,
      response,
    };

    const correctAnswer = [wordMetadata.IMG_URL];

    this.setState((prevState) => ({
      isCorrect,
      results: newResults,
      buttonsDisabled: true,
    }));

    if (isCorrect) {
      this.setState(
        { buttonsDisabled: true },
        () => {
          if(isCorrect && selectionHistory.length === 1){
            this.props.speech.speak({ 
              textToSpeak: this.ttsStrings.correct_response,
              onEnd: this.close,
            });
          } else {
            if(getUserData().bilingualMode) {
              this.props.speech.speakSequence({
                textToSpeak: [
                  {textToSpeak: this.ttsStrings.correct_response},
                  {textToSpeak: word, skipTranslation: true},
                  {textToSpeak: this.ttsStrings.means},
                  {textToSpeak: wordMetadata.DEFINITION.default, skipTranslation: true},
                ],
                onEnd: this.close,
              });
            } else {
              this.props.speech.speak({
                textToSpeak:`${this.ttsStrings.correct_response} ${word} ${this.ttsStrings.means} ${wordMetadata.DEFINITION.default}.`,
                onEnd: this.close,
              });
            }
          }

        }
      );

    } else {
      this.speakEncouragement({
        text: getRandomArrayElement(COPY_STRINGS.intervention_strings.comprehensionWrongAnswer),
        callback: this.enableButtons,
      });
    }
  }

  close() {
    if (!this.isMounted) return;

    this.setState(
      { isClosed: true },
      this.props.handleMessage({
        continueWithoutSpeaking: true,
        endOfPhrase: this.props.endOfPhrase,
      })
    );
  }

  expire() {
    if (!this.isMounted) return;
    const { word, wordMetadata } = this.props;

    if(getUserData().bilingualMode) {
      this.props.speech.speakSequence({
        textToSpeak: [
          {textToSpeak: word, skipTranslation: true},
          {textToSpeak: this.ttsStrings.means},
          {textToSpeak: wordMetadata.DEFINITION.default, skipTranslation: true},
        ],
        onEnd: this.close,
      });
    } else {
      this.props.speech.speak({
        textToSpeak:`${word} ${this.ttsStrings.means} ${wordMetadata.DEFINITION.default}.`,
        onEnd: this.close,
      });
    }
  }

  render() {
    const { word, wordMetadata } = this.props;
    const correctAnswer =
      wordMetadata && wordMetadata.IMG_URL
        ? wordMetadata.IMG_URL
        : "";
    const bilingualQuestion = {
      english: `${this.ttsStrings.question_text} ${word}?`,
      speechArray: [
        {textToSpeak: this.ttsStrings.question_text},
        {textToSpeak: word, skipTranslation: true},
      ],
    }
    const questionTitle = bilingualQuestion.english;
    const wordClasses = cx({
      word: true,
      longWord: word ? word.length > 8 : false,
    });

    return (
      <div>
        <div className="wordInterventionModal">
          <div className="vocabularyWithPictureContainer">
            <div className="vocabularyWithPictureHeading">
              <div className="icon">
                <img className="interventionIcon" src={vocabularyIcon} alt="" />
              </div>
              <div className="right">
                <div className={wordClasses}>
                  <span>{word}</span>
                </div>
              </div>
            </div>
            <div className="vocabularyWithPictureSelection">
              {word && (
                <PictureMultipleChoice
                  options={this.state.distractors}
                  bilingualQuestion={bilingualQuestion}
                  correctAnswer={[correctAnswer]}
                  speech={this.props.speech}
                  flat={true}
                  readQuestion={true}
                  updateResults={this.updateResults}
                  buttonsDisabled={this.state.buttonsDisabled}
                  enableButtons={this.enableButtons}
                  disableButtons={this.disableButtons}
                  expire={this.expire}
                  questionTitle={questionTitle}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

VocabularyWithPicture.propTypes = {
  word: PropTypes.string,
  wordMetadata: PropTypes.object,
  endOfPhrase: PropTypes.bool,
  speech: PropTypes.object,
  handleMessage: PropTypes.func,
};
